module.exports = __webpack_public_path__ + "img/fi-rr-time-oclock.f55c95f2.svg";